import React from "react";
import { Resource } from "@/types/resource";

type Props = {
  resources: Resource[];
};

const ResourceStats: React.FC<Props> = ({ resources }) => {
  const total = resources.length;
  // The API docs do not provide download counts; show placeholder aggregated value or calculate if you have counts
  const totalDownloads = "—"; // not provided in API docs
  const categories = Array.from(
    new Set(resources.map((r) => r.type).filter(Boolean))
  );
  const contributors = "—";

  return (
    <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mt-4">
      <div className="bg-white p-4 rounded-md shadow-sm">
        <div className="text-sm text-slate-500">Total Resources</div>
        <div className="text-2xl font-semibold mt-2">{total}</div>
      </div>

      <div className="bg-white p-4 rounded-md shadow-sm">
        <div className="text-sm text-slate-500">Total Downloads</div>
        <div className="text-2xl font-semibold mt-2">{totalDownloads}</div>
      </div>

      <div className="bg-white p-4 rounded-md shadow-sm">
        <div className="text-sm text-slate-500">Categories</div>
        <div className="text-2xl font-semibold mt-2">{categories.length}</div>
      </div>

      <div className="bg-white p-4 rounded-md shadow-sm">
        <div className="text-sm text-slate-500">Contributors</div>
        <div className="text-2xl font-semibold mt-2">{contributors}</div>
      </div>
    </div>
  );
};

export default ResourceStats;
